import { List } from '@epicuro-next/models/engagement';
import { createAction, props } from '@ngrx/store';

/**
 * Action for pre check if you need to create or not active list before saving products based on a search query.
 */
export const checkActiveList = createAction('[ProductList] Check active list');

/**
 * Action for saving products in a list based on a search query.
 */
export const saveAllItemsInList = createAction(
  '[ProductList] Save all items in product List',
  props<{ list: List }>(),
);

/**
 * Success action for saving products in a list based on a search query.
 */
export const saveAllItemsInListSuccess = createAction(
  '[ProductList] Save all items in product List Success',
  props<{ id: string }>(),
);

/**
 * Error action for saving products in a list based on a search query.
 */
export const saveAllItemsInListError = createAction(
  '[ProductList] Save all items in product List Error',
);
